function expandables(){
	var $controls = $(".expand[aria-controls][aria-pressed]");
	$controls.on('click',function(e)
	{
		e.preventDefault();
		var $me = $(this);
		var isOpen = $me.attr("aria-pressed").toLowerCase() == "true";
		var id = $me.attr("aria-controls");
		var el = document.getElementById(id);
		if (el){
			var $el = $(el);
			$("[aria-controls=" + id + "]").not($el).attr("aria-pressed", (!isOpen).toString().toLowerCase());
			$el.attr("aria-hidden", isOpen.toString().toLowerCase());
		}
	});
}
function tabletNavigation() {
	var $toggleMenu = $('.has-dropdown > a');
	$toggleMenu.on('click', function(e){
		var checkTablet = window.matchMedia('(min-width: 320px) and (max-width: 1280px)');
		var $expand = $(this).next('.expand[aria-pressed=false]');
		if (checkTablet.matches && $expand.length){
			e.preventDefault();
			$expand.trigger("click");
		}
	});
}
function vehicleNavigation() {
	var vehicleTab = $('.vehicle-tab');
	var vehcileCategory = $('.vehicle-category');
	vehicleTab.on('click', function (e) {
		e.preventDefault();
		var $this = $(this),
			tabType = $this.attr('data-type');
		vehcileCategory.removeClass('active');
		$this.parent('li').addClass('active');
		$('.details ul').each(function () {
			$(this).removeClass('open');
			var tab = $(this).attr('data-type');
			if (tabType === tab) {
				$(this).addClass('open');
			}
		});
	});
}
function handleResize0(){
	setTimeout(function(){
		setNewVehiclesColumnWidth();
	},600);
}
function setNewVehiclesColumnWidth(){
	var $dd = $('.dropdown.new-vehicles')
	var $ul = $dd.children('ul');
	if ($(window).outerWidth() >= 768){
		var $parent = $ul.closest('.has-dropdown');
		var newWidth = $parent.outerWidth();
		var realWidth = Math.max(newWidth, parseInt($ul.css("min-width") || 0));
		$ul.css("flex-basis", realWidth + "px"); 
	}
	else {
		$ul.css("flex-basis", "auto");
	}
}
function setActive(){
	var $firstLevelLis = $("#ac-site-nav > .ac-container > ul > li");
	var $as = $firstLevelLis.find("a").sort(function(l, r){
		return $(l).parent().hasClass("nav-root-level") ? -1 : 1;
	});
	$as.each(function(){
		var $me = $(this);
		var href = $me.attr("href");
		if ((location.pathname == '/' || href != '/') && -1 != location.href.indexOf(href)){
			var $topLevelLi = $me.closest($firstLevelLis);
			$topLevelLi.addClass("active");
			return false;
		}
	});
}
function setToggles(){
	$("#ac-nav-toggle").on("click", function (e) {
		$("body").toggleClass("ac-nav-visible");
		e.preventDefault();
	});
}

jQuery(function($){
	var resizeTimer0;
	$(window).on('resize', function(e) {
		clearTimeout(resizeTimer0);
		resizeTimer0 = setTimeout(handleResize0, 250);
	});
	expandables();
	vehicleNavigation();
	tabletNavigation();
	setActive();
	setToggles();
	setNewVehiclesColumnWidth();
	if (document.fonts && document.fonts.ready){
		document.fonts.ready.then(function () {
			setNewVehiclesColumnWidth();
		});
	}
});